export const ADMIN_ROOT_PATH = '/admin' as const

export const ADMIN_SECTION_CONFIG = {
  overview: {
    key: 'overview',
    path: 'overview',
    routeName: 'admin-overview',
    label: '概览',
    title: '发布概览',
    icon: 'activity',
  },
  worlds: {
    key: 'worlds',
    path: 'worlds',
    routeName: 'admin-worlds',
    label: '世界管理',
    title: '世界管理',
    icon: 'map',
  },
  rendering: {
    key: 'rendering',
    path: 'rendering',
    routeName: 'admin-rendering',
    label: '渲染系统状态',
    title: '渲染系统状态',
    icon: 'activity',
  },
  styles: {
    key: 'styles',
    path: 'styles',
    routeName: 'admin-styles',
    label: '对象样式',
    title: '对象样式',
    icon: 'sliders',
  },
  accounts: {
    key: 'accounts',
    path: 'accounts',
    routeName: 'admin-accounts',
    label: '测绘员账户',
    title: '测绘员账户',
    icon: 'users',
    editionFeature: 'surveyorAccountManagement',
  },
  audit: {
    key: 'audit',
    path: 'audit',
    routeName: 'admin-audit',
    label: '审计日志',
    title: '审计日志',
    icon: 'file',
    editionFeature: 'auditLog',
  },
} as const

export const ADMIN_MERGE_REQUEST_CONFIG = {
  key: 'merge',
  path: 'merge-requests',
  routeName: 'admin-merge-requests',
  detailRouteName: 'admin-merge-request-detail',
  label: '合并请求',
  icon: 'pullRequest',
  editionFeature: 'mergeRequests',
} as const

export type AdminSection = keyof typeof ADMIN_SECTION_CONFIG
export type AdminNavigationKey = AdminSection | typeof ADMIN_MERGE_REQUEST_CONFIG.key
export type EditionFeatureKey = 'surveyorAccountManagement' | 'mergeRequests' | 'publishHistory' | 'auditLog'

export const ADMIN_NAV_GROUPS = [
  {
    label: '工作区',
    items: [
      ADMIN_SECTION_CONFIG.overview,
      ADMIN_SECTION_CONFIG.worlds,
      ADMIN_SECTION_CONFIG.rendering,
      ADMIN_MERGE_REQUEST_CONFIG,
      ADMIN_SECTION_CONFIG.styles,
    ],
  },
  {
    label: '访问权限',
    items: [
      ADMIN_SECTION_CONFIG.accounts,
      ADMIN_SECTION_CONFIG.audit,
    ],
  },
] as const

const teamFeatureBySection: Partial<Record<AdminSection, EditionFeatureKey>> = {
  accounts: 'surveyorAccountManagement',
  audit: 'auditLog',
}

export const adminNavGroupsFor = (features: Partial<Record<EditionFeatureKey, boolean>> = {}) => (
  ADMIN_NAV_GROUPS
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => {
        const feature = item.key === ADMIN_MERGE_REQUEST_CONFIG.key
          ? ADMIN_MERGE_REQUEST_CONFIG.editionFeature
          : teamFeatureBySection[item.key as AdminSection]
        return !feature || features[feature] !== false
      }),
    }))
    .filter((group) => group.items.length)
)

export const isAdminSection = (value: unknown): value is AdminSection => (
  typeof value === 'string' && value in ADMIN_SECTION_CONFIG
)

export const adminSectionPath = (section: AdminSection) => `${ADMIN_ROOT_PATH}/${ADMIN_SECTION_CONFIG[section].path}`
export const adminMergeRequestsPath = `${ADMIN_ROOT_PATH}/${ADMIN_MERGE_REQUEST_CONFIG.path}`
